import { mimeMapping } from '../../../components/files/mimes';

(function() {
  'use strict';

    /*
        interface File {
            name: string;
            type: string;
            contentType: string;
            size: number;
            status: string;
        }
    */


/*
      const turnitInOptions = {
        enabled: field.enableAntiPlagiarism,
        attempts: field.enableAntiPlagiarismAttempts,
        required: field.enableAntiPlagiarismRequired,
        buttonLabel: field.enableAntiPlagiarismTitle
      };
*/

  const TURNITIN_PENDING_STATES = ['file_pending', 'report_not_requested', 'report_pending'];

  const defaultFileOptions = {
    accept: ['all'],
    multiple: false,
    sizeLimit: 100,
    fileLimit: 0,
    storeSingle: false
  };

  const getReadableFileSizeString = function(fileSizeInBytes) {
    if (!fileSizeInBytes) {
      return 0;
    }

    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes /= 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  };


  function FileWidget($q, Files, FileUpload, Turnitin, Notify, $translate, FILE_TYPES) {
    var ctrl = this;

    ctrl.files = [];
    ctrl.usedAttempts = 0;

      // Convert data model to a file model
    ctrl.modelToFileModel = async function(model) {
      let currentHash = Turnitin.getHash(model);
      var currentSubmission;
      if (ctrl.turnitInOptions?.enabled) {
        if (!model.key && model.turnitin && model.turnitin.submissions) {
          currentSubmission = model.turnitin.submissions[model.turnitin.submissions.length - 1];
        }
        const subObj = await Turnitin.getByOrigin(
          ctrl.originId,
          ctrl.fieldId,
          model.key
        );
        if (subObj.lastSubmission) {
          currentSubmission = subObj.lastSubmission;
        }

        if (currentSubmission && currentSubmission.uploaded_hash !== currentHash) {
          currentSubmission = undefined;
        }
      }

      return {
        filename: model.filename,
        type: mimeMapping[model.contentType] ?? model.type ?? model.filename.split('.').pop(),
        contentType: model.contentType,
        size: model.size,
        readableSize: getReadableFileSizeString(model.size),
        vendor: model.vendor,
        key: model.key,
        status: 'uploaded',
        currentSubmission: currentSubmission,
        model: model,
        currentHash: currentHash,
        turnitin: model.turnitin,
        legacyId: model.legacyId
      };
    };

    // Convert browser file to a file model
    ctrl.fileToFileModel = function(file) {
      return {
        filename: file.name,
        type: mimeMapping[file.type] ?? file.type.split('/')[1],
        contentType: file.type,
        size: file.size,
        readableSize: getReadableFileSizeString(file.size),
        status: 'waiting',
        file: file,
        turnitin: file.turnitin,
        legacyId: file.legacyId
      };
    };

    // Convert file model to data model for saving
    ctrl.fileModelToModel = function(file) {
      if (file.status !== 'uploaded') {
        throw new Error('File is not uploaded');
      }

      return {
        filename: file.filename,
        type: file.type,
        contentType: file.contentType,
        size: file.size,
        vendor: file.vendor,
        key: file.key,
        turnitin: file.turnitin,
        legacyId: file.legacyId
      };
    };

    ctrl.handleButtons = function() {
      ctrl.files.forEach(file => {
        file.buttons = ctrl.actions.filter(action => action.showCondition(file));
      });
    };

    ctrl.getAccept = function(value) {
      if (value === undefined || value === null) {
        return '';
      }

      if (!Array.isArray(value)) {
        value = [value];
      }

      const types = value.reduce(function(acc, type) {
        const tp = _.find(FILE_TYPES, { id: type });
        if (tp) {
          acc.push(tp.accept);
        }
        return acc;
      }, []);

      return types.join(',');
    };

    ctrl.getTypeName = function(type) {
      const tp = _.find(FILE_TYPES, { id: type });
      return tp ? tp.descriptor : '';
    };

    ctrl.$onInit = async function() {
      let files = ctrl.model || [];
      ctrl.turnitinKey = `__turnitin__${ctrl.fieldKey}`;
      ctrl.ngModelCtrl.$setValidity('fileStatus', true);
      if (ctrl.turnitInOptions?.enabled) {
        ctrl.usedAttempts = 0;
        if (ctrl.fileFields[ctrl.turnitinKey] &&
          ctrl.fileFields[ctrl.turnitinKey]?.submissions.length > 0) {
          ctrl.usedAttempts = ctrl.fileFields[ctrl.turnitinKey].submissions.length;
        }
        const subObj = await Turnitin.getByOrigin(
            ctrl.originId,
            ctrl.fieldId,
            ''
        );
        ctrl.usedAttempts += subObj.usedAttempts;
      }
      ctrl.actions = [
        {
          label: $translate.instant('Download'),
          klass: 'btn-primary',
          showCondition: file => ctrl.readOnly && file.status === 'uploaded',
          action: file => ctrl.download(file)
        },
        {
          label: $translate.instant('Preview'),
          klass: 'btn-primary',
          showCondition: file => {
            if (!ctrl.readOnly) {
              return false;
            }

            if (file.status !== 'uploaded') {
              return false;
            }

            if (!file.contentType) {
              return false;
            }

            if (file.contentType.startsWith('image') || file.contentType === 'application/pdf') {
              return true;
            }

            if (file.contentType === 'pdf' || file.contentType === 'png' ||
                file.contentType === 'jpg' || file.contentType === 'jpeg'
            ) {
              return true;
            }
            return false;
          },
          action: file => ctrl.preview(file)
        },
        {
          label: $translate.instant('Replace'),
          klass: 'btn-primary',
          showCondition: file => {
            return !ctrl.readOnly && ctrl.allowEdit &&
            (file.status === 'uploaded' || file.status === 'failed');
          },
          action: file => ctrl.replace(file)
        },
        {
          label: $translate.instant('Remove'),
          klass: 'btn-danger',
          showCondition: file =>
            !ctrl.readOnly && (file.status === 'uploaded' || file.status === 'failed'),
          action: file => ctrl.remove(file)
        },
        {
          label: ctrl.turnitInOptions?.buttonLabel || $translate.instant('Check for plagiarism'),
          klass: 'btn-primary',
          showCondition: file => {
            if (!ctrl.turnitInOptions?.enabled) {
              return false;
            }

            if (ctrl.readOnly) {
              return false;
            }

            if (file.status !== 'uploaded') {
              return false;
            }

            const state = file.currentSubmission?.state?.state;
            if (TURNITIN_PENDING_STATES.includes(state)) {
              return false;
            }

            if (
              state === 'complete' &&
              Turnitin.getHash(file.model) === file.currentSubmission.uploaded_hash
            ) {
              return false;
            }
            const { attempts } = ctrl.turnitInOptions;
            const remainingAttempts = attempts - ctrl.usedAttempts;
            if (remainingAttempts < 1 && attempts > 0) {
              return false;
            }
            return true;
          },
          action: file => ctrl.checkForPlagiarism(file)
        },
        {
          label: $translate.instant('View plagiarism detail'),
          klass: 'btn-primary',
          showCondition: file => {
            if (!ctrl.turnitInOptions?.enabled) {
              return false;
            }

            if (file.status !== 'uploaded') {
              return false;
            }

            if (file.currentSubmission === undefined || file.currentSubmission === null) {
              return false;
            }

            const state = file.currentSubmission?.state?.state;
            if (Turnitin.getHash(file.model) !== file.currentSubmission.uploaded_hash) {
              return false;
            }

            return state === 'complete';
          },
          action: file => ctrl.viewPlagiarismDetail(file)
        }
      ];
      if (!Array.isArray(files)) {
        files = [files];
      }
      ctrl.files = await $q.all(files.map(file => ctrl.modelToFileModel(file)));
      ctrl.uploadedCount = ctrl.files.filter(file => file.status === 'uploaded').length;
      ctrl.startAllUpdators();
      ctrl.handleButtons();
      if (!ctrl.readOnly) {
        ctrl.handleModel();
      }
    };

    ctrl.$onChanges = function() {
      ctrl.fullFileOptions = {
        ...defaultFileOptions,
        ...ctrl.fileOptions
      };

      ctrl.fullFileOptions.fileLimit = ctrl.fullFileOptions.multiple ?
        ctrl.fullFileOptions.fileLimit || 0 : 1;

      ctrl.allowEdit = ctrl.removeOnly === undefined ? true : !ctrl.removeOnly;
      ctrl.handleButtons();
    };

    ctrl.upload = function(files) {
      const uploadedFiles = Array.from(files).map(file => ctrl.fileToFileModel(file));
      ctrl.files = ctrl.files.concat(uploadedFiles);
      ctrl.handleFiles();
    };

    ctrl.validateFile = function(file) {
      // Validate mime type
      if (ctrl.fullFileOptions.accept) {
        const accept = ctrl.getAccept(ctrl.fullFileOptions.accept);
        if (accept) {
          const valid = accept.split(',').some(type => {
            type = type.trim();
            if (type.startsWith('.')) {
              return file.filename.endsWith(type);
            }
            const stripped = type.split('*')[0];
            return file.contentType.startsWith(stripped);
          });

          if (!valid) {
            return {
              status: 'error',
              message: 'Invalid file type'
            };
          }
        }
      }

      // Validate file size
      if (ctrl.fullFileOptions.sizeLimit
        && file.size > ctrl.fullFileOptions.sizeLimit * 1024 * 1024
      ) {
        return {
          status: 'error',
          message: 'File is too large'
        };
      }

      // Validate file count
      if (ctrl.fullFileOptions.fileLimit) {
        const count = ctrl.files.filter(
            f => f.status === 'uploaded' || f.status === 'uploading'
        ).length;
        if (count >= ctrl.fullFileOptions.fileLimit) {
          return {
            status: 'error',
            message: 'Too many files'
          };
        }
      }

      return {
        message: 'File is valid'
      };
    };


    ctrl.handleFiles = function() {
      ctrl.files.forEach(function(file) {
        if (file.status === 'waiting') {
          const status = ctrl.validateFile(file);
          if (status.status === 'error') {
            file.status = 'failed';
            file.error = status.message;
            return;
          }

          ctrl.ngModelCtrl.$setValidity('fileStatus', false);

          file.status = 'uploading';
          FileUpload.uploadToS3(file.file, { oid: ctrl.docId, name: file.filename }, progress => {
            console.log('Setting progress', progress);
            file.progress = progress;
          })
            .then(function(model) {
              file.key = model.key;
              file.model = model;
              file.vendor = model.vendor;
              file.status = 'uploaded';
              file.currentHash = Turnitin.getHash(file.model);
              ctrl.handleModel();
              ctrl.handleButtons();
            })
            .catch(function(err) {
              file.status = 'failed';
              Notify.error(err);
              ctrl.handleModel();
              ctrl.handleButtons();
            });
        }

        if (file.currentSubmission) {
          file.currentHash = Turnitin.getHash(file.model);
        }
      });
      ctrl.handleButtons();
    };

    ctrl.handleModel = function() {
      const uploadedFiles = ctrl.files.filter(file => file.status === 'uploaded');
      const data = uploadedFiles.map(file => ctrl.fileModelToModel(file));

      ctrl.uploadedCount = data.length;
      if (!ctrl.fullFileOptions.multiple && ctrl.fullFileOptions.storeSingle) {
        ctrl.model = data.length > 0 ? data[0] : null;
      } else {
        ctrl.model = data;
      }

      if (ctrl.onModelUpdated) {
        ctrl.onModelUpdated({ files: uploadedFiles });
      }
      const pendingFiles = ctrl.files.filter(file => file.status === 'uploading');
      ctrl.ngModelCtrl.$setValidity('fileStatus', pendingFiles.length === 0);
    };

    ctrl.replace = function(file) {
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = ctrl.getAccept(ctrl.fullFileOptions.accept);
      input.onchange = function() {
        var files = input.files;
        if (files.length > 0) {
          const fileModel = ctrl.fileToFileModel(files[0]);
          _.extend(file, fileModel);
          ctrl.handleFiles();
        }
      };
      input.click();
    };

    ctrl.select = function() {
      var input = document.createElement('input');
      input.type = 'file';
      input.multiple = ctrl.fullFileOptions.multiple;
      input.accept = ctrl.getAccept(ctrl.fullFileOptions.accept);
      input.onchange = function() {
        var files = input.files;
        if (files.length > 0) {
          ctrl.upload(files);
        }
      };
      input.click();
    };

    ctrl.download = function(file) {
      FileUpload.getDownloadUrl(file.model, { oid: ctrl.docId })
                .then(function(res) {
                  window.open(res.url, '_blank');
                })
                .catch(function(err) {
                  console.log(err);
                  Notify.error(err.message || 'The file cannot be downloaded');
                });
    };

    ctrl.preview = function(file) {
      Files.openPreviewModal(file.model, ctrl.docId);
    };

    ctrl.remove = function(file) {
      ctrl.files = ctrl.files.filter(f => f !== file);
      ctrl.handleModel();
    };

    ctrl.checkForPlagiarism = function(file) {
      if (file.status !== 'uploaded') {
        return;
      }
      if (ctrl.nextAllowedSubmission && ctrl.nextAllowedSubmission.isAfter()) {
        Notify.error('You have used all your submissions. Please wait for an extra attempt');
        return;
      }

      if (ctrl.turnitInOptions && ctrl.turnitInOptions.enabled) {
        const origin = {
          fieldId: ctrl.fieldId,
          originId: ctrl.originId,
          attempts: ctrl.turnitInOptions.attempts,
          fileKey: file.model.key
        };

        Turnitin.submitFile(
          file.model,
          ctrl.turnitInOptions.title,
          { oid: ctrl.docId, origin: origin }
        )
          .then(function(submission) {
            // ctrl.fileFields[ctrl.turnitinKey].submissions.push(
            //   {
            //     id: submission.id,
            //     date: submission.created_date
            //   }
            // );
            // if (!file.turnitin) {
            //   file.turnitin = { submissions: [] };
            // }
            // file.turnitin.submissions.push(submission);
            file.currentSubmission = submission;
            file.currentHash = Turnitin.getHash(file.model);
            ctrl.handleModel();
            ctrl.handleButtons();
            ctrl.updator(submission);
            ctrl.updateUsedAttempts();
          }).catch(function(err) {
            console.error(err);
            Notify.error(
              err.message || 'Turnitin service is currently unavailable. Please try again later.'
            );
          });
      }
    };

    ctrl.updateUsedAttempts = async function() {
      if (!ctrl.turnitInOptions?.enabled) {
        return;
      }
      // let usedAttempts = 0;
      // let latestCreatedDate;
      ctrl.usedAttempts = 0;
      if (ctrl.fileFields[ctrl.turnitinKey]) {
        ctrl.usedAttempts = ctrl.fileFields[ctrl.turnitinKey].submissions.length;
      }
      const subObj = await Turnitin.getByOrigin(ctrl.originId, ctrl.fieldId, '');
      ctrl.usedAttempts += subObj.usedAttempts;
          // .then(function(res) {
          //   ctrl.usedAttempts = res.usedAttempts;
            // usedAttempts = _.filter(ctrl.fileFields[ctrl.turnitinKey].submissions,
            // function(sub) {
            //   if (latestCreatedDate === undefined) {
            //     latestCreatedDate = sub.date;
            //   }
            //   if (sub.date > latestCreatedDate) {
            //     latestCreatedDate = sub.date;
            //   }
            //   return true;
            // }).length;
            // if (ctrl.turnitInOptions.attempts) {
            //   if (ctrl.turnitInOptions.attempts - ctrl.usedAttempts <= 0) {
            //     var dt = moment(latestCreatedDate);
            //     dt.add(1, 'days');
            //     ctrl.nextAllowedSubmission = dt;
            //   } else {
            //     ctrl.nextAllowedSubmission = undefined;
            //   }
            // } else {
            //   ctrl.nextAllowedSubmission = undefined;
            // }
          // });
    };

    ctrl.viewPlagiarismDetail = function(file) {
      if (!file.currentSubmission) {
        return;
      }

      Turnitin.openViewer(file.currentSubmission);
    };

    ctrl.updator = function(submission) {
      if (Turnitin.isFinished(submission)) {
        return;
      }

      if (ctrl.readOnly) {
        return false;
      }

      return Turnitin.waitFor(submission)
        .then(function(newSubmission) {
          console.log('Finished');
          _.extend(submission, newSubmission);
          ctrl.handleModel();
          ctrl.handleButtons();
        }, null, function(newSubmission) {
          console.log('Updating');
          _.extend(submission, newSubmission);
          ctrl.handleModel();
          ctrl.handleButtons();
        })
        .catch(function(err) {
          console.error(err);
          Notify.error(
            err.message || 'Turnitin service is currently unavailable. ' +
            'Please try again later.'
          );
        });
    };

    ctrl.startAllUpdators = function() {
      ctrl.files.forEach(file => {
        if (file.currentSubmission) {
          ctrl.updator(file.currentSubmission);
        }
      });
    };

    ctrl.stopAllUpdators = function() {
      ctrl.files.forEach(file => {
        if (file.currentSubmission) {
          ctrl.stopUpdator(file.currentSubmission);
        }
      });
    };

    ctrl.stopUpdator = function(submission) {
      Turnitin.stopUpdator(submission);
    };

    ctrl.$onDestroy = function() {
      ctrl.stopAllUpdators();
    };
  }

  FileWidget.$inject = [
    '$q',
    'FilesService',
    'FileUploadService',
    'TurnitinService',
    'NotifyService',
    '$translate',
    'FILE_TYPES'
  ];

  angular.module('blocks.utils')
        .component('fileWidget', {
          templateUrl: 'app/blocks/widgets/forms/file-widget.html',
          controller: FileWidget,
          require: {
            ngModelCtrl: 'ngModel'
          },
          bindings: {
            label: '<',
            model: '=',
            fileFields: '=',
            fieldKey: '=',
            readOnly: '<',
            originId: '<',
            fieldId: '<',
            removeOnly: '<',
            docId: '<',
            required: '@',
            hideList: '<',
            fileOptions: '<',
            turnitInOptions: '<',
            onModelUpdated: '&'
          }
        });
})();
